module.exports = __webpack_public_path__ + "static/media/tejas.2a2bbbec.png";